import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { OpenLinkButton } from '@cbridge-tools/button';
import { ISectionSourceLinkProps } from './SectionSourceLink.interface';

export const SectionSourceLink: FunctionComponent<ISectionSourceLinkProps> = ({ href, name }) => {
  const { t } = useTranslation();

  if (!href) {
    return null;
  }

  return (
    <>
      {name && (
        <Typography variant={'caption'} color={'textDisabled'}>
          {t('text:common.misc.sourceSubtitle', '', { name })}
        </Typography>
      )}
      <OpenLinkButton href={href} />
    </>
  );
};
